import React from 'react';
import { KeyRound } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-dark border-t border-border-dark/60">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-card border border-border-dark rounded-[2rem] p-8 sm:p-12">
          <span className="text-accent text-sm font-bold uppercase tracking-[0.2em]">{t.about.kicker}</span>
          <h2 className="mt-3 text-3xl lg:text-4xl font-extrabold text-white font-heading">
            {t.about.title}
          </h2>

          <p className="mt-6 text-lg text-slate-300 leading-relaxed">{t.about.intro}</p>

          <div className="mt-8 flex items-start gap-4 bg-primary/10 border border-primary/25 rounded-2xl p-5">
            <span className="mt-0.5 w-10 h-10 rounded-xl bg-gradient-to-br from-primary to-pink flex items-center justify-center shrink-0">
              <KeyRound className="w-5 h-5 text-white" />
            </span>
            <p className="text-base text-white font-semibold leading-snug">{t.about.activation}</p>
          </div>

          <div className="mt-8 space-y-4">
            {t.about.paragraphs.map((p) => (
              <p key={p} className="text-sm text-slate-400 leading-relaxed">
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
